export class Provider {
  constructor(
    public providerId?: string,
    public providerName?: string,
    public providerParty?: string,
    public region?: string,
    public providerDesc?: string,
    public country?: string,
    public bu?: string,
    public createTime?: number
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/provider/provider.model.ts